import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { littletonNhConfig } from "./data";

export default function LittletonNhPage() {
  return <CityPageTemplate config={littletonNhConfig} />;
}